import { get } from 'lodash';
import { UnknownAction } from 'redux';

// Utils
import { getParentScrollableSectionForElement } from '../../../utils/dom/getParentScrollableSection';
import { ScrollCleanupConfig } from './scrollExcessHandler';

// Selectors
import { getSelectedElementIds } from '../../../element/selection/selectedElementsSelector';
import {
    getCurrentlyEditingEditorKey,
    getCurrentlyEditingId,
} from '../../../element/selection/currentlyEditingSelector';
import { getElementIdForSelectedLabel } from '../../../element/labels/labelSelectors';

// Constants
import {
    ELEMENT_EDIT_COMPLETE,
    ELEMENTS_DESELECT_ALL,
    ELEMENTS_DESELECTED,
} from '../../../../common/elements/selectionConstants';
import { DOCUMENT_MODAL_EDITOR_KEY } from '../../../element/document/modal/documentModalConstants';
import { SheetActionTypes } from '../../structural/sheet/sheetActionTypes';
import { SheetId } from '../../structural/sheet/sheetTypes';
import { LABEL_RENAME_FINISH } from '../../../../common/labels/labelConstants';

/**
 * Returns the scroll excess cleanup required after an action is dispatched.
 */
export const getScrollCleanupConfigForAction = (state: any, action: UnknownAction): ScrollCleanupConfig | undefined => {
    if (action.type === SheetActionTypes.SHEET_CLOSE) {
        return { sheetId: action.sheetId as SheetId };
    }

    let elementId;

    if (action.type === ELEMENT_EDIT_COMPLETE) {
        const editorKey = getCurrentlyEditingEditorKey(state);
        if (editorKey === DOCUMENT_MODAL_EDITOR_KEY)
            return { scrollableParent: document.getElementById('document-modal-content-scrollable-container') };

        elementId = getCurrentlyEditingId(state);
    }

    if (action.type === ELEMENTS_DESELECTED) {
        elementId = get(action.ids, 0);
    }

    if (action.type === ELEMENTS_DESELECT_ALL) {
        elementId = get(getSelectedElementIds(state), 0);
    }

    if (action.type === LABEL_RENAME_FINISH) {
        elementId = getElementIdForSelectedLabel(state);
    }

    return elementId && { scrollableParent: getParentScrollableSectionForElement(elementId) };
};
